module.exports = __webpack_public_path__ + "article-7051a3ee/das-ultimative-handbuch-fuer-empfeh-bc75c8f73298fbdcddc6791559824c24.jpeg";